export default "__VITE_PUBLIC_ASSET__dccb0609__"